import { CustomContent, CustomContentComponentConfig, CustomContentComponentModel, HawkSearchComponents } from '@models';
import { BaseContentComponent } from '../base-content.component';
import defaultHtml from './custom-content.component.hbs';

export class CustomContentComponent extends BaseContentComponent<CustomContentComponentConfig, CustomContent, CustomContentComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'custom-content';
    protected override defaultHtml = defaultHtml;

    protected override renderContent(): boolean {
        return !!this.data;
    }

    protected override getContentModel(): CustomContentComponentModel {
        return {
            ...this.data!
        };
    }
}
